import { useRecoilValue } from 'recoil';

import { apiGet } from '../services/_common';
import { useQuery } from '@tanstack/react-query';
import { userState } from '../atoms';

interface IService {
  path: string;
  req?: any;
  queryKey?: string;
  hCdOnly?: { value: boolean; key: 'hCd' | 'cCd' }; // 본사코드 만으로 조회
  hasParam?: boolean;
  useLoginUserInfo?: boolean;
  enabledKey?: boolean;
  refetchInterval?: number;
}

const GetFetchStatus = (param: IService) => {
  const userInfo = useRecoilValue(userState);
  const { hCd, sCd } = userInfo;
  const { path, queryKey, hCdOnly = { value: false, key: 'hCd' }, hasParam = true, useLoginUserInfo = true, enabledKey, refetchInterval } = param;

  const fetchData = async () => {
    try {
      const req = useLoginUserInfo ? (hCdOnly.value ? { ...param.req, [hCdOnly.key]: hCd } : { ...param.req, hCd, sCd }) : { ...param.req };
      const res = hasParam ? await apiGet({ path, req }) : await apiGet({ path });
      return res.data.data;
    } catch (error) {
      console.error(error);
      throw new Error('error');
    }
  };

  const queryKeyString = queryKey ? `${path}_${queryKey}` : `${path}`;

  const { data, isLoading, isFetching, isRefetching, isError, refetch } = useQuery([queryKeyString, hCd, sCd], () => fetchData(), {
    enabled: enabledKey !== undefined ? enabledKey && !!hCd && !!sCd : !!hCd && !!sCd,
    ...(refetchInterval !== undefined && { refetchInterval }),
  });

  return { data, isLoading, isFetching, isRefetching, isError, refetch };
};

export default GetFetchStatus;
